/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IssueCsrfToken200Response,
  IssueCsrfToken400Response,
  Login200Response,
  LoginRequest,
  VerifyMailToken200Response,
} from '../models/index';
import {
    IssueCsrfToken200ResponseFromJSON,
    IssueCsrfToken200ResponseToJSON,
    IssueCsrfToken400ResponseFromJSON,
    IssueCsrfToken400ResponseToJSON,
    Login200ResponseFromJSON,
    Login200ResponseToJSON,
    LoginRequestFromJSON,
    LoginRequestToJSON,
    VerifyMailToken200ResponseFromJSON,
    VerifyMailToken200ResponseToJSON,
} from '../models/index';

export interface LoginOperationRequest {
    loginRequest?: LoginRequest;
}

export interface VerifyMailTokenRequest {
    xTokenType: string;
    xMAILToken: string;
}

/**
 * 
 */
export class CertificationApi extends runtime.BaseAPI {

    /**
     * CSRFトークンを返却します。
     * トークン発行
     */
    async issueCsrfTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/certification/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken200ResponseFromJSON(jsonValue));
    }

    /**
     * CSRFトークンを返却します。
     * トークン発行
     */
    async issueCsrfToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken200Response> {
        const response = await this.issueCsrfTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     * 企業の認証を行います。
     * ユーザー認証
     */
    async loginRaw(requestParameters: LoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Login200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/certification/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestToJSON(requestParameters.loginRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Login200ResponseFromJSON(jsonValue));
    }

    /**
     * 企業の認証を行います。
     * ユーザー認証
     */
    async login(requestParameters: LoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Login200Response> {
        const response = await this.loginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 企業ユーザーのログアウト対応を行います。 発行済みのトークンはreissue時に有効期限切れとなります。
     * ログアウト
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IssueCsrfToken400Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/certification/logout`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IssueCsrfToken400ResponseFromJSON(jsonValue));
    }

    /**
     * 企業ユーザーのログアウト対応を行います。 発行済みのトークンはreissue時に有効期限切れとなります。
     * ログアウト
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IssueCsrfToken400Response> {
        const response = await this.logoutRaw(initOverrides);
        return await response.value();
    }

    /**
     * 企業ユーザーの再認証を行います。フロントのシステム内での自動延長用です。
     * トークン再発行
     */
    async reissueRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Login200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/certification/reissue`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Login200ResponseFromJSON(jsonValue));
    }

    /**
     * 企業ユーザーの再認証を行います。フロントのシステム内での自動延長用です。
     * トークン再発行
     */
    async reissue(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Login200Response> {
        const response = await this.reissueRaw(initOverrides);
        return await response.value();
    }

    /**
     * アカウント発行、メールアドレス変更、パスワード変更時のリンクURLに付与されているトークン整合性を確認します。 アカウント発行、メールアドレス変更の場合は完了メールを送信します。
     * メール認証
     */
    async verifyMailTokenRaw(requestParameters: VerifyMailTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyMailToken200Response>> {
        if (requestParameters.xTokenType === null || requestParameters.xTokenType === undefined) {
            throw new runtime.RequiredError('xTokenType','Required parameter requestParameters.xTokenType was null or undefined when calling verifyMailToken.');
        }

        if (requestParameters.xMAILToken === null || requestParameters.xMAILToken === undefined) {
            throw new runtime.RequiredError('xMAILToken','Required parameter requestParameters.xMAILToken was null or undefined when calling verifyMailToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xTokenType !== undefined && requestParameters.xTokenType !== null) {
            headerParameters['X-Token-Type'] = String(requestParameters.xTokenType);
        }

        if (requestParameters.xMAILToken !== undefined && requestParameters.xMAILToken !== null) {
            headerParameters['X-MAIL-Token'] = String(requestParameters.xMAILToken);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/certification/mail`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VerifyMailToken200ResponseFromJSON(jsonValue));
    }

    /**
     * アカウント発行、メールアドレス変更、パスワード変更時のリンクURLに付与されているトークン整合性を確認します。 アカウント発行、メールアドレス変更の場合は完了メールを送信します。
     * メール認証
     */
    async verifyMailToken(requestParameters: VerifyMailTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyMailToken200Response> {
        const response = await this.verifyMailTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
